import React from 'react';
import PropTypes from 'prop-types';

import PaginatorBlock from 'components/PaginatorBlock';

import css from './PressReleaseBlock.module.scss';
import debounce from 'lodash/debounce';
import cn from 'classnames';

import Button from 'components/Button';
import Media from 'components/Media';
import DropdownFilter from 'components/DropdownFilter';
import TableBlock from 'components/TableBlock';
import ContactBlock from 'components/ContactBlock';

const DEBOUNCE_DURATION = 500;

class PressReleaseBlock extends React.Component {
    static propTypes = {
        parentHeading: PropTypes.string,
        parentLink: PropTypes.string,
        heading: PropTypes.string,
        apiUrl: PropTypes.string.isRequired,
        months: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            value: PropTypes.string
        })),
        monthsHeading: PropTypes.string,
        years: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            value: PropTypes.string
        })),
        yearsHeading: PropTypes.string,
        divisions: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            value: PropTypes.string
        })),
        divisionsHeading: PropTypes.string,
        filterHeading: PropTypes.string,
        articles: PropTypes.shape({
            items: PropTypes.arrayOf(PropTypes.shape({
                title: PropTypes.string,
                date: PropTypes.string,
                division: PropTypes.string,
                link: PropTypes.string
            })),
            totalCount: PropTypes.number
        }),
        initialDivision: PropTypes.number,
        language: PropTypes.string,
        defaultPageSize: PropTypes.number,
        image: Media.propTypes.image,
        contactsHeading: PropTypes.string,
        contacts: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            emailAddress: PropTypes.string,

            title: PropTypes.string,
            profilePicture: PropTypes.string,
            department: PropTypes.string,
            phone: PropTypes.string,
            externalSystemId: PropTypes.string
        })),
        pagerLabels: PropTypes.shape({
            prevButton: PropTypes.string,
            nextButton: PropTypes.string,
        })

    }

    state = {
        month: undefined,
        year: undefined,
        division: this.props.initialDivision,
        articles: this.props.articles,
        page: 1,
        pageSize: this.props.defaultPageSize,
        language: this.props.language,
        searching: false,
    }

    pageChange = (page) => {
        this.setState({
            page: page
        }, this._debouncedFilterItems);
    }
    _yearFilter = (e, value) => {
        this.setState({
            page: 1,
            year: value ? value : undefined
        }, this._debouncedFilterItems);
    }
    _monthFilter = (e, value) => {
        this.setState({
            page: 1,
            month: value ? value : undefined
        }, this._debouncedFilterItems);
    }
    _divisionFilter = (e, value) => {
        this.setState({
            page: 1,
            division: value
        }, this._debouncedFilterItems);
    }

    _filterItems = () => {
        const filter = { ...this.state };

        const search = () => {
            window.fetch(this.props.apiUrl, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                method: 'POST',
                body: JSON.stringify(filter)
            }).then(res => {
                if (!res.ok) {
                    this.setState({
                        searching: false,
                    });

                    return console.error(res);
                }

                res.json().then(json => {
                    this.setState({
                        articles: json,
                        searching: false,
                    });
                });
            }).catch(err => {
                console.error(err);

                this.setState({
                    searching: false,
                });
            });
        };

        this.setState({
            searching: true,
        }, search);
    }

    _debouncedFilterItems = debounce(this._filterItems, DEBOUNCE_DURATION)

    render() {
        const {
            parentHeading,
            parentLink,
            heading,
            months,
            monthsHeading,
            years,
            yearsHeading,
            divisions,
            divisionsHeading,
            filterHeading,
            image,
            contactsHeading,
            contacts,
            pagerLabels,
        } = this.props;

        const {
            articles,
            division,
            page,
            pageSize
        } = this.state;

        return (
            <div className={css.block}>
                <div className={css.header}>
                    <Media image={image} alt={heading} />
                    <div className={css.inner}>
                        <div className={css.content}>
                            <a href={parentLink}><span>{parentHeading}</span></a>
                            <h1>{heading}</h1>
                        </div>
                    </div>
                </div>
                <div className={css.filters}>
                    <ul>
                        <li>
                            <DropdownFilter yellow heading={monthsHeading} items={months} onSelect={this._monthFilter} />
                        </li>
                        <li>
                            <DropdownFilter yellow heading={yearsHeading} items={years} onSelect={this._yearFilter} />
                        </li>
                        <li>
                            <DropdownFilter yellow active={division} heading={divisionsHeading} items={divisions} onSelect={this._divisionFilter} />
                        </li>
                        <li>
                            <Button secondary onClick={this._debouncedFilterItems}>{filterHeading}</Button>
                        </li>
                    </ul>
                </div>
                <div className={css["list-outer"]}>
                    <div className={cn(css.list, {
                        [css.searching]: this.state.searching
                    })}>
                        <TableBlock data={articles.items.map((item) => {
                            return {
                                ...item,
                                "title": item.link ? "<a href="+item.link+">"+item.title+"</a>" : item.title
                            };
                        })} keys={["date", "title", "division"]}/>
                    </div>
                    <PaginatorBlock 
                        pages={Math.ceil(articles.totalCount / pageSize)} 
                        currentPage={page} onPageChange={this.pageChange} 
                        prevButtonLabel={pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null}
                        nextButtonLabel={pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null}
                    />
                </div>
                <ContactBlock heading={contactsHeading} contacts={contacts} />
            </div>
        );
    }
}

export default PressReleaseBlock;



// WEBPACK FOOTER //
// ./src/components/PressReleaseBlock/PressReleaseBlock.jsx